import React, { useState, useEffect } from 'react';
import {
  Text,
  Flex,
  Button,
  Spinner,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  useDisclosure,
  Alert,
  AlertIcon,
  useToast,
  Divider,
} from '@chakra-ui/react';
import moment from 'moment';
import Card from 'components/card/Card';
import { Formik, Form, Field } from 'formik';
import InputField from 'components/formComponents/inputField';
import CustomerSavingPlanApi from 'api/customersavingplan';
import MultiLineSelectField from 'components/formComponents/multiLineSelectField';
import StoresApi from 'api/stores';
import CustomerApi from 'api/customer';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export const OrderSummaryPage = ({
  values,
  setStep,
  enrollmentId,
  orderSummary,
}) => {
  const [orderSummaryResponse, setOrderSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const history = useHistory();
  const {
    isOpen: isOTPOpen,
    onOpen: onOTPOpen,
    onClose: onOTPClose,
  } = useDisclosure();
  const [receiptNumber, setReceiptNumber] = useState('');
  const [store, setStore] = useState('');
  const [stores, setStores] = useState([]);

  const [OTPResponse, setOTPResponse] = useState({});

  const [OTP, setOTP] = useState('');
  const [lastDigits, setLastDigits] = useState('');

  const [customer, setCustomer] = useState({});
  const [paymentError, setPaymentError] = useState('');
  console.log('Order summary', orderSummary);
  const storeOptions = stores.map((branch) => ({
    value: branch.id,
    titleLabel: `${branch.name} (${branch.store_code})`,
    // subLabel: branch.address_line1,
    bodyLabel: `${branch.city} ${branch.state} ${branch.pincode}`,
  }));

  useEffect(() => {
    const fetchStores = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await StoresApi.List({
          sort: 'name:asc',
          itemsPerPage: 100,
        });
        setStores(response.data.data.list);
      } catch (error) {
        setError('Failed to fetch stores');
      }
      setLoading(false);
    };

    const FetchCustomerData = async () => {
      try {
        setLoading(true);
        let response = await CustomerApi.getById(
          orderSummary?.customer_saving_plan?.user_id || orderSummary?.user_id
        );
        response = response.data;
        setLoading(false);
        if (response.status_code === 200) {
          console.log('Received from API', response);
          setCustomer(response?.data);
        } else {
          setCustomer({});
        }
      } catch (err) {
        console.log(err);
      }
    };

    FetchCustomerData();
    fetchStores();
    //fetchOrderSummary();
  }, [enrollmentId]);

  const handleCashPayment = async (values) => {
    console.log('handleCashPayment called with values:', values);
    if (!values.receiptNumber || !values.storeId) {
      setPaymentError('Receipt number and store are required.');
      return;
    }
    try {
      const response = await CustomerSavingPlanApi.postCashTransaction({
        orderId: orderSummary?.id,
        recipt_number: values.receiptNumber,
        storeId: values.storeId,
      });

      setOrderSummary(response.data.data);
      const url = `/admin/order/${orderSummary?.id}`;
      window.open(url, '_self');
      onClose();
    } catch (error) {
      setPaymentError('Failed to process cash payment. Please try again.');
    }
  };

  const handleSendCloseOTP = async (values) => {
    console.log('handleSendCloseOTP called with values:', values);
    // if (!values.receiptNumber || !values.storeId) {
    //   setPaymentError('Receipt number and store are required.');
    //   return;
    // }
    try {
      const response = await CustomerSavingPlanApi.SendOTPCloseAccount({
        orderId: orderSummary?.id,
        userId: orderSummary?.user_id,
      });
      console.log('Respoinse from handleSendCloseOTP ', response);
      setOTPResponse(response.data.data);
      onOTPOpen();
    } catch (error) {
      console.log('Error recieved');
    }
  };
  const sendCloseOTP = () => {
    handleSendCloseOTP();
    // onSendOTPOpen();
  };
  const handleOTPSubmit = async () => {
    try {
      const response = await CustomerSavingPlanApi.verifyOTPCloseAccount({
        orderId: orderSummary?.id,
        userId: orderSummary?.user_id,
        otp: OTP,
        otpId: OTPResponse?.otp_id,
      });
      console.log('Respoinse from handleSendCloseOTP ', response);
      setOTPResponse(response.data.data);
      onOTPOpen();
      if (response.status_code !== 200) {
        console.log('Status code in verify OTP', response.data.status_code);
        history.push('/admin/orders/');
        toast({
          title: response?.data?.message || 'Invalid OTP, please try again',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
      if (response.status_code === 200) {
        history.push('/admin/orders/');
      }
    } catch (error) {
      console.log('Error recieved');
    }
    console.log('OTP Submitted:', OTP); // Added
  };

  const handleClickForPayOnline = () => {
    const dataString = JSON.stringify({ orderId: orderSummary?.id });
    window.open(
      `/admin/paymentgateway?data=${encodeURIComponent(dataString)}`,
      '_blank'
    );
  };

  return (
    <Flex
      mt='8rem'
      direction='column'
      gap={6}
      maxWidth={
        orderSummary?.order_type === 'CLOSE_SAVING_PLAN' ? '2xl' : '7xl'
      }
    >
      <Text textAlign='center' fontSize='3xl' fontWeight='500'>
        Order Summary
      </Text>
      <Card
        bg={
          orderSummary?.order_type === 'CLOSE_SAVING_PLAN'
            ? 'brand.50'
            : 'gray.200'
        }
      >
        {loading ? (
          <Flex justify='center' alignItems='center' height='200px'>
            <Spinner size='xl' />
          </Flex>
        ) : error ? (
          <Alert status='error'>
            <AlertIcon />
            {error}
          </Alert>
        ) : (
          <Flex direction='column' gap={8}>
            <Flex direction={{ base: 'column', md: 'row' }} gap={8}>
              {orderSummary?.order_type === 'CLOSE_SAVING_PLAN' ? (
                <>
                  <Flex direction='column' gap={3} width='100%'>
                    <Card display='flex' height='100%'>
                      <Flex direction='column' gap={4}>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>Plan</Text>
                          <Text ml={2}>
                            {orderSummary?.customer_saving_plan?.category ||
                              'N/A'}
                          </Text>
                        </Flex>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>Category</Text>
                          <Text ml={2}>
                            {orderSummary?.details.customer_saving_plan_details
                              ?.category || 'N/A'}
                          </Text>
                        </Flex>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>Start Date</Text>
                          <Text ml={2}>
                            {moment(
                              orderSummary?.details.customer_saving_plan_details
                                .start_date
                            ).format('DD MMM YY, HH:mm')}
                          </Text>
                        </Flex>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>End Date</Text>
                          <Text ml={2}>
                            {orderSummary?.order_item
                              ? `Rs ${orderSummary?.order_item[0]?.amount}`
                              : 'N/A'}
                          </Text>
                        </Flex>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>Time Period</Text>
                          <Text ml={2}>
                            {orderSummary?.details.customer_saving_plan_details
                              .total_month
                              ? `${orderSummary?.details.customer_saving_plan_details.total_month} Months`
                              : 'N/A'}
                          </Text>
                        </Flex>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>Account Number</Text>
                          <Text ml={2}>
                            {orderSummary?.details.customer_saving_plan_details
                              .account_number || 'N/A'}
                          </Text>
                        </Flex>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>
                            Total Deposited Amount
                          </Text>
                          <Text ml={2}>
                            {orderSummary?.details.customer_saving_plan_details
                              .total_deposited_amount
                              ? `Rs ${orderSummary?.details.customer_saving_plan_details.total_deposited_amount}`
                              : 'N/A'}
                          </Text>
                        </Flex>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>
                            Total Gold Weight (gms)
                          </Text>
                          <Text ml={2}>
                            {orderSummary?.order_item[0].details
                              .total_gold_weight || 'N/A'}
                          </Text>
                        </Flex>
                      </Flex>
                    </Card>
                  </Flex>
                </>
              ) : (
                <>
                  <Flex direction='column' gap={3} width='100%'>
                    <Text align='center' fontSize='2xl' fontWeight='500'>
                      Plan Details
                    </Text>
                    <Card display='flex' height='100%'>
                      <Flex direction='column' gap={4}>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>Scheme No.</Text>
                          <Text ml={2}>
                            {orderSummary?.customer_saving_plan?.account_number ||
                              'N/A'}
                          </Text>
                        </Flex>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>Total Amount</Text>
                          <Text>
                           Rs {orderSummary?.customer_saving_plan?.total_amount ||
                              'N/A'}
                          </Text>
                        </Flex>

                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>Monthly Investment</Text>
                          <Text ml={2}>
                            Rs {orderSummary?.customer_saving_plan
                              ?.monthly_amount || 'N/A'}
                          </Text>
                        </Flex>
                        <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>Time Period</Text>
                          <Text>
                            {orderSummary?.customer_saving_plan?.total_month
                              ? `${orderSummary?.customer_saving_plan?.total_month} Months`
                              : 'N/A'}
                          </Text>
                        </Flex>
                        {/* <Flex justifyContent='space-between' gap={2}>
                          <Text fontWeight='medium'>Saving Plan Unique ID</Text>
                          <Text>
                            {
                              orderSummary?.customer_saving_plan
                                ?.nominee_phone_number
                            }
                          </Text>
                        </Flex> */}
                      </Flex>
                    </Card>
                  </Flex>
                </>
              )}

              {orderSummary?.order_type !== 'CLOSE_SAVING_PLAN' && (
                <>
                  <Flex direction='column' gap={3} width='100%'>
                    <Text align='center' fontSize='2xl' fontWeight='500'>
                      {orderSummary?.order_type === 'INSTALLMENT_SAVING_PLAN'
                        ? 'Installment Details'
                        : 'Payment Details'}
                    </Text>
                    <Card display='flex' height='100%'>
                      <Flex direction='column' gap={4}>
                        {orderSummary?.order_item &&
                        orderSummary.order_item.length > 0 ? (
                          orderSummary.order_item.map((item, index) => (
                            <Flex
                              key={index}
                              justifyContent='space-between'
                              gap={2}
                            >
                              <Text fontWeight='medium'>{item.type}</Text>
                              <Text ml={2}>Rs {item.amount}</Text>
                            </Flex>
                          ))
                        ) : (
                          <Text>No installments available</Text>
                        )}
                      </Flex>
                    </Card>
                  </Flex>
                </>
              )}
            </Flex>
            {orderSummary?.order_type !== 'CLOSE_SAVING_PLAN' && (
              <Flex direction={{ base: 'column', md: 'row' }} gap={8}>
                <Flex direction='column' gap={3} width='100%'>
                  <Text align='center' fontSize='2xl' fontWeight='500'>
                    Personal Details
                  </Text>
                  <Card display='flex' height='100%'>
                    <Flex direction='column' gap={4}>
                      <Flex justifyContent='space-between' gap={2}>
                        <Text fontWeight='medium'>Name</Text>
                        <Text ml={2}>
                          {customer?.customer
                            ? customer?.customer?.name
                            : 'N/A'}
                        </Text>
                      </Flex>
                      <Flex justifyContent='space-between' gap={2}>
                        <Text fontWeight='medium'>Phone No.</Text>
                        <Text ml={2}>
                          {customer?.customer
                            ? `${customer?.customer?.phone_number}`
                            : 'N/A'}
                        </Text>
                      </Flex>
                      <Flex justifyContent='space-between' gap={2}>
                        <Text fontWeight='medium'>Address</Text>
                        <Text maxW='250px' textAlign='right'>
                          {customer?.address
                            ? `${customer?.address?.permanent?.address_line1}, ${customer?.address?.permanent?.address_line2}, ${customer?.address?.permanent?.city}, ${customer?.address?.permanent?.state}, ${customer?.address?.permanent?.pincode}`
                            : 'N/A'}
                        </Text>
                      </Flex>
                      <Divider borderColor='gray.500' />
                      <Flex justifyContent='space-between' gap={2}>
                        <Text fontWeight='medium'>Nominee Name</Text>
                        <Text ml={2}>
                          {orderSummary?.customer_saving_plan
                            ? orderSummary?.customer_saving_plan?.nominee_name
                            : 'N/A'}
                        </Text>
                      </Flex>
                      <Flex justifyContent='space-between' gap={2}>
                        <Text fontWeight='medium'>Nominee Ph. No.</Text>
                        <Text ml={2}>
                          {orderSummary?.customer_saving_plan
                            ? orderSummary?.customer_saving_plan
                                ?.nominee_phone_number
                            : 'N/A'}
                        </Text>
                      </Flex>
                    </Flex>
                  </Card>
                </Flex>
                {orderSummary?.order_type !== 'CLOSE_SAVING_PLAN' && (
                  <>
                    <Flex direction='column' gap={3} width='100%'>
                      <Text align='center' fontSize='2xl' fontWeight='500'>
                        Beneficiary Details
                      </Text>
                      <Card display='flex' height='100%'>
                        <Flex direction='column' gap={4}>
                          <Flex justifyContent='space-between' gap={2}>
                            <Text fontWeight='medium'>Beneficiary Name</Text>
                            <Text ml={2}>
                              {orderSummary?.customer_saving_plan
                                ? orderSummary?.customer_saving_plan
                                    ?.company_name
                                : 'N/A'}
                            </Text>
                          </Flex>

                          <Flex justifyContent='space-between' gap={2}>
                            <Text fontWeight='medium'>Address</Text>
                            <Text maxW='200px' textAlign='right'>
                              {orderSummary?.customer_saving_plan
                                ? `${orderSummary?.customer_saving_plan?.company_address_line1}, 
                                ${orderSummary?.customer_saving_plan?.company_address_line2}
                                `
                                : 'N/A'}
                            </Text>
                          </Flex>
                          <Flex justifyContent='space-between' gap={2}>
                            <Text fontWeight='medium'>Phone No.</Text>
                            <Text ml={2}>
                              {orderSummary?.customer_saving_plan
                                ? orderSummary?.customer_saving_plan
                                    ?.company_phone_number
                                : 'N/A'}
                            </Text>
                          </Flex>
                          <Flex justifyContent='space-between' gap={2}>
                            <Text fontWeight='medium'>E-Mail</Text>
                            <Text ml={2}>
                              {orderSummary?.customer_saving_plan
                                ? orderSummary?.customer_saving_plan
                                    ?.company_email
                                : 'N/A'}
                            </Text>
                          </Flex>
                        </Flex>
                      </Card>
                    </Flex>
                  </>
                )}
              </Flex>
            )}

            <Card
              display='flex'
              direction='column'
              align='start'
              mt={2}
              p={5}
              bg={
                orderSummary?.order_type === 'CLOSE_SAVING_PLAN'
                  ? 'brand.50'
                  : 'gray.200'
              }
            >
              <Checkbox
                colorScheme='blue'
                isChecked={acceptTerms}
                iconColor={acceptTerms ? 'white' : 'gray.500'}
                borderColor={acceptTerms ? 'blue.500' : 'gray.500'}
                _hover={{ borderColor: 'blue' }}
                onChange={(e) => setAcceptTerms(e.target.checked)}
                mb={3}
              >
                I confirm that the terms and conditions have been explained to the customer.
              </Checkbox>
              {orderSummary?.order_type === 'CLOSE_SAVING_PLAN' ? (
                <Button
                  //onClick={() => setStep(4)}
                  onClick={sendCloseOTP}
                  colorScheme='blue'
                  isDisabled={!acceptTerms}
                  width='100%'
                >
                  Send OTP
                </Button>
              ) : (
                <Flex justify='space-between' width='100%' gap={4}>
                  <Button
                    //onClick={() => setStep(4)}
                    onClick={handleClickForPayOnline}
                    colorScheme='blue'
                    isDisabled={!acceptTerms}
                    width='100%'
                  >
                    {`Pay Online Rs.${orderSummary?.total_amount}`}
                  </Button>
                  <Button
                    onClick={onOpen}
                    colorScheme='green'
                    isDisabled={!acceptTerms}
                    width='100%'
                  >
                    {`Pay with Cash Rs.${orderSummary?.total_amount}`}
                  </Button>
                </Flex>
              )}
            </Card>
          </Flex>
        )}

        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Pay with Cash</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>
                <b>Order Code:</b> {orderSummary?.code || 'N/A'}
              </Text>
              <Formik
                initialValues={{ receiptNumber: '', storeId: '' }}
                onSubmit={handleCashPayment}
              >
                {({ setFieldValue }) => (
                  <Form>
                    <Flex direction='column'>
                      <InputField
                        placeholder='Receipt Number'
                        name='receiptNumber'
                        mt={3}
                        // onChange={(e) => {
                        //   setFieldValue('receiptNumber', e.target.value);
                        //   setReceiptNumber(e.target.value);
                        // }}
                      />
                      <MultiLineSelectField
                        name='storeId'
                        label='Branch Name'
                        options={storeOptions}
                        required
                        //   onChange={(value) => {
                        //     console.log('Value', value);
                        //     setFieldValue('storeId', value?.value);
                        //   }}
                      />
                    </Flex>
                    <ModalFooter>
                      <Button colorScheme='blue' mr={3} type='submit'>
                        Submit
                      </Button>
                      <Button variant='ghost' onClick={onClose}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </ModalBody>
          </ModalContent>
        </Modal>

        <Modal isOpen={isOTPOpen} onClose={onOTPClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Enter OTP</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text mb={4}>
                An SMS with a verification code is sent to your phone {'  '}
                {OTPResponse?.country_code}- XXXXXX
                {OTPResponse?.phone_number?.slice(-4)}
              </Text>
              <Input
                placeholder='Enter OTP'
                value={OTP}
                onChange={(e) => setOTP(e.target.value)}
                maxLength={6}
                mb={4}
              />
            </ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' onClick={handleOTPSubmit}>
                Submit OTP{' '}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Card>
    </Flex>
  );
};
